// extracted by mini-css-extract-plugin
module.exports = {"profileAttribute":"styles_profileAttribute__2BbJX"};